import { cn as e } from "../shared/utils.js";
import { Checkbox as t } from "./primitive/index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/checkbox/checkbox-control.tsx
function i({ checked: i, defaultChecked: a, description: o, descriptionProps: s, disabled: c, indicatorProps: l, indeterminate: u, label: d, labelProps: f, name: p, onCheckedChange: m, readOnly: h, required: g, rootProps: _, size: v = "md", value: y }) {
	let b = c ?? _?.disabled, x = !!d, S = !!o;
	return /* @__PURE__ */ r("label", {
		className: e("text-text-primary inline-flex min-w-0 gap-2 text-base font-normal", S ? "items-start" : "items-center", b ? "text-text-disabled cursor-not-allowed" : "cursor-pointer"),
		children: [/* @__PURE__ */ n(t.Root, {
			..._,
			checked: i,
			className: _?.className,
			defaultChecked: a,
			disabled: b,
			indeterminate: u,
			name: p,
			onCheckedChange: m,
			readOnly: h,
			required: g,
			size: v,
			value: y,
			children: /* @__PURE__ */ n(t.Indicator, {
				...l,
				className: l?.className,
				size: v
			})
		}), (x || S) && /* @__PURE__ */ r("span", {
			className: "flex min-w-0 flex-col gap-1",
			children: [x && /* @__PURE__ */ n("span", {
				...f,
				className: e("min-w-0 leading-5", f?.className),
				children: d
			}), S && /* @__PURE__ */ n("span", {
				...s,
				className: e("min-w-0 text-sm/5", b ? "text-text-disabled" : "text-text-tertiary", s?.className),
				children: o
			})]
		})]
	});
}
//#endregion
export { i as CheckboxControl };
